var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title,"fixed":"","url":_vm.url,"border":_vm.border,"left-arrow":_vm.leftArrow},on:{"click-left":_vm.onClickLeft}})
}
var staticRenderFns = []

export { render, staticRenderFns }